import React from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { ProductGrid } from "@/components/product/ProductGrid";
import { useProducts } from "@/hooks/useCatalog";

export function BestSellers({ onQuickView }) {
  const { data, isLoading } = useProducts({ tag: "bestseller", limit: 8, sort: "best-selling" });

  return (
    <section className="bg-cream py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Loved by Many"
          title="Best Sellers"
          align="left"
          link={{ label: "View All", to: "/collections/best-sellers", testId: "best-sellers-view-all" }}
        />
        <div className="mt-12">
          <ProductGrid products={data?.items || []} loading={isLoading} onQuickView={onQuickView} />
        </div>
      </div>
    </section>
  );
}
